<template>
  <div class="quick-launch-all-product" :style="{ display: allProductDisplay }" @click="onSwitchItem">
    <div>{{this.title}}</div>
  </div>
</template>

<script>

  let lpUtils = require('../../../../assets/js/utils/lpUtils.js');
  import { leButton } from 'lp-vue-components';
  import { Logger } from 'vue-infra';

  const logger = Logger.getLogger('LiveEngage:QuickLaunch');

  export default {

    components: {
        leButton
    },
    props: {
      title: String,
      url: String,
      iconURL: String
    },
    data: function () {
      return {
        showDefaultIcon: false,
      }
    },
    computed: {
      getInitialsLetters: function () {
        return lpUtils.initialsFromString(this.title);
      },
      icon() {
        if (typeof this.iconURL !== 'undefined'){
          return this.iconURL;
        } else {
          this.showDefaultIcon = true;
        }
      },
      isNeedToShowDefaultIcon() {
        return this.showDefaultIcon ? 'block' : 'none';
      },
      isNeedToShowApplicationIcon() {
        return this.showDefaultIcon ? 'none' : 'block';
      }
    },
    methods: {
      onSwitchItem(event) {
        event.stopPropagation();
        window.LE.navigator.open(this.url, '_blank');
        this.$emit('clicked');
        logger.bam({
          serviceName: 'CCUI-CORE',
          appName: 'CCUI',
          eventName: 'marketing application launched',
          widgetName: 'cc-applications',
          value: this.title,
        });
      },
      onImageLoadFailure () {
        this.showDefaultIcon = true;
      }
    }
  }
</script>

<style lang='scss' scoped>
  @import "../../../../assets/scss/global";
  @import "../../../../assets/scss/mixins";

  .quick-launch-all-product {
    height: 40px;
    border-radius: 8px;
    @include themify {
      background-color: getColor('quick-launch-all-product-bg-color', 'framework');
    };
    margin: 5px;
    font-family: Roboto;
    font-size: 10px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      @include themify {
        border: 1px solid getColor('quick-launch-app-icon-hover-border-color', 'framework');
        background-color: getColor('quick-launch-app-icon-hover-bg-color', 'framework');
        @include box-shadow(
            getSize('quick-launch-app-hover-shadow-color-h-offset', 'framework')
            getSize('quick-launch-app-hover-shadow-color-v-offset', 'framework')
            getSize('quick-launch-app-hover-shadow-color-blur', 'framework')
            getSize('quick-launch-app-hover-shadow-color-spread', 'framework')
            getColor('quick-launch-app-icon-hover-border-shadow', 'framework')
        );
      };
      margin: 4px;
    }
    flex-grow: 1;
    cursor: pointer;
  }

  .quick-launch-all-product div {
    text-decoration: none;
    @include themify {
      color: getColor('quick-launch-dropdown-border-color', 'framework');
    };

  }


</style>
